import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Leaf, BookOpen, ArrowRight, Heart, Sparkles } from "lucide-react";
import { ShopHeader } from "../components/shop/ShopHeader";
import { ShopFooter } from "../components/shop/ShopFooter";

const BODY_IMG = "/products/noumabou-gamme.jpg";

export default function BrandHome() {
  return (
    <div className="App overflow-x-hidden">
      <ShopHeader />

      <section className="relative">
        <div className="w-full max-w-md mx-auto sm:max-w-7xl px-4 sm:px-6 lg:px-8 pt-14 pb-8 sm:pt-20 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <span className="inline-flex items-center gap-2 uppercase text-xs tracking-[0.2em] font-semibold text-brand-accent">
              <Sparkles className="w-4 h-4" /> Noumabou International
            </span>
            <h1 className="font-heading text-4xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-none text-brand-ink mt-5">
              Nourrir l'âme,<br /><span className="text-brand">soigner le corps.</span>
            </h1>
            <p className="text-base sm:text-lg leading-relaxed text-brand-sub mt-6 max-w-2xl mx-auto">
              Une seule mission, deux chemins : un ministère qui élève l'esprit, et des compléments
              naturels qui prennent soin du corps.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="w-full max-w-md mx-auto sm:max-w-7xl px-4 sm:px-6 lg:px-8 pb-16">
        <div className="grid md:grid-cols-2 gap-6">
          <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <Link to="/ministere" data-testid="door-ministere" className="group block bg-white rounded-3xl overflow-hidden border border-brand-line shadow-sm hover:shadow-xl transition-shadow duration-300 h-full">
              <div className="aspect-[4/3] overflow-hidden flex items-center justify-center" style={{ background: "#F1E6CE" }}>
                <img src="https://customer-assets.emergentagent.com/job_vital-store-1/artifacts/nfu8u877_867BA37A-687A-40EB-8E67-795E5BE0FEF6.PNG" alt="Ministère Noumabou" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-7">
                <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-accent"><BookOpen className="w-4 h-4" /> Nourrir l'âme</span>
                <h2 className="font-heading text-3xl font-black mt-2 text-brand-ink">Le Ministère</h2>
                <p className="text-brand-sub text-sm mt-2 max-w-sm">Livres, École du Royaume de Dieu, et bientôt l'application Bible Royale d'Étude.</p>
                <span className="inline-flex items-center gap-2 mt-4 font-semibold text-brand group-hover:gap-3 transition-all">Découvrir <ArrowRight className="w-4 h-4" /></span>
              </div>
            </Link>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}>
            <Link to="/boutique" data-testid="door-boutique" className="group block bg-white rounded-3xl overflow-hidden border border-brand-line shadow-sm hover:shadow-xl transition-shadow duration-300 h-full">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={BODY_IMG} alt="Boutique Noumabou" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-7">
                <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-accent"><Leaf className="w-4 h-4" /> Soigner le corps</span>
                <h2 className="font-heading text-3xl font-black mt-2 text-brand-ink">La Boutique</h2>
                <p className="text-brand-sub text-sm mt-2 max-w-sm">Compléments alimentaires naturels au Togo. Paiement Tmoney, Flooz ou en ligne.</p>
                <span className="inline-flex items-center gap-2 mt-4 font-semibold text-brand group-hover:gap-3 transition-all">Voir les produits <ArrowRight className="w-4 h-4" /></span>
              </div>
            </Link>
          </motion.div>
        </div>

        <div className="mt-10 bg-white border border-brand-line rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
          <span className="w-14 h-14 rounded-2xl bg-brand/10 text-brand flex items-center justify-center shrink-0"><Heart className="w-7 h-7" /></span>
          <div className="flex-1">
            <h3 className="font-heading text-xl font-bold text-brand-ink">Soutenez la mission</h3>
            <p className="text-brand-sub text-sm mt-1">Votre don aide à porter le message du Royaume et à développer nos projets.</p>
          </div>
          <Link to="/ministere#don" data-testid="home-donate" className="bg-brand text-white hover:bg-brand-hover transition-colors rounded-full px-6 py-3 font-semibold whitespace-nowrap">Faire un don</Link>
        </div>
      </section>

      <ShopFooter />
    </div>
  );
}
